module.exports = __webpack_public_path__ + "static/media/grid-image-1.415028da.png";